import React, { useRef, useEffect, useState } from "react";
import Layout from "../components/Layout";
import Sectiontitle from "../components/Sectiontitle";
import Card from "../components/Card";
import BgDotGrid from "../components/BgDotGrid";
import Slider from "react-slick";
import LineIcon from "react-lineicons";
import { sliderSettings } from "../constants/constants";

sliderSettings.infinite = false;

function FinancialServices() {
  const sliderRef = useRef();
  const [apps, setApps] = useState([]);

  useEffect(() => {
    fetch("/apps/industry/Financial%20Services")
      .then(r => r.json())
      .then(data => setApps(data))
      .catch(() => {});
  }, []);

  const items = apps.Items || [];

  return (
    <Layout>
      <div className="mi-comms mi-section">
        <BgDotGrid />
        <div className="content-container">
          <Sectiontitle title={`Financial Services (${items.length})`} />
          <div className="slider-wrapper">
            <button className="slider-control" onClick={() => sliderRef.current.slickPrev()}>
              <LineIcon name="chevron-left" />
            </button>
            <Slider ref={sliderRef} className="mi-card-slider" {...sliderSettings}>
              {items.map((item, index) => <Card key={index} {...item} />)}
            </Slider>
            <button className="slider-control" onClick={() => sliderRef.current.slickNext()}>
              <LineIcon name="chevron-right" />
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default FinancialServices;
